module.exports = __webpack_public_path__ + "dda25f86e45a55202af7bfa91d6fc771.svg";